import apiClient from './apiClient';

export interface Zone {
  id: string;
  label: string;
  identifier: string;
  sportIdentifier: string;
  sportLabel: string | null;
  pctIcMin: number;
  pctIcMax: number;
  inUse: boolean;
}

export interface ZonePayload {
  label: string;
  identifier: string;
  sportIdentifier: string;
  pctIcMin: number;
  pctIcMax: number;
}

export const getZones = async (filters: { search?: string; sport?: string }): Promise<Zone[]> => {
  const response = await apiClient.get('admin/zones', { params: filters });
  return response.data as Zone[];
};

export const createZone = async (payload: ZonePayload): Promise<Zone> => {
  const response = await apiClient.post('admin/zones', payload);
  return response.data as Zone;
};

export const updateZone = async (id: string, payload: ZonePayload): Promise<Zone> => {
  const response = await apiClient.put(`admin/zones/${id}`, payload);
  return response.data as Zone;
};

export const deleteZone = async (id: string): Promise<void> => {
  await apiClient.delete(`admin/zones/${id}`);
};
